module.exports = __webpack_public_path__ + "img/23.f795c715.png";